require('../../modules/es.array.iterator');
require('../../modules/es.object.from-entries');

module.exports = require('../../internals/path').Object.fromEntries;
